import { Component, Inject } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Util } from 'app/models/util';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-citation-dialog',
  standalone: true,
  imports: [CommonModule,MatDialogModule,MatButtonModule, MatDialogModule, MatIconModule, NgClass,MatIconModule],
  templateUrl: './citation-dialog.component.html',
  styleUrl: './citation-dialog.component.scss'
})
export class CitationDialogComponent {

  fileName: string = '';
  fileIcon: string = '';
  markedContent:SafeHtml = null;
  constructor(
  @Inject(MAT_DIALOG_DATA) public data: { documentName:string, content: string, theme:string,pageNumbers:string },
  private util:Util
) {
    if (data?.documentName) {
      this.fileName = data.documentName;
      const ext = this.getFileExtension(this.fileName);
      this.fileIcon = this.util.getFileTypeImage(ext);
    }
    this.markedContent = this.util.getMarkedContent(data.content);

  }

  private getFileExtension(name: string): string {
    return name.split('.').pop()?.toLowerCase() || '';
  }

}
